export default __webpack_public_path__ + "fonts/remove-contact-button-pressed.svg";